import React from 'react';
import PropTypes from 'prop-types';

function Signature({ value = '', onChange, readOnly = false }) {
  return (
    <div className="flex items-center justify-center text-[#5a3e36] w-full h-full px-[3%] gap-[0.5rem] text-[clamp(0.65rem,1vw,0.875rem)]">
      <label
        htmlFor="signatureInput"
        className="font-medium whitespace-nowrap"
      >
        Signature:
      </label>

      {readOnly ? (
        <div className="
          text-[clamp(0.75rem,1.1vw,1rem)] leading-[clamp(1rem,1.25rem,1.2rem)]
          border border-[#e0c3a5] bg-white rounded
          w-[clamp(9rem,70%,300px)] h-[clamp(1.75rem,5vw,2.25rem)]
          px-[2%]
          flex items-center justify-center
          truncate whitespace-nowrap box-border
        ">
          {value?.trim()
            ? value
            : <span className="text-transparent select-none">.</span>}
        </div>
      ) : (
        <input
          id="signatureInput"
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={value === '' ? '' : 'Your name'}
          className="
            text-[clamp(0.75rem,1.1vw,1rem)] leading-[clamp(1rem,1.25rem,1.2rem)]
            font-sans border border-[#e0c3a5] bg-white rounded
            w-[clamp(9rem,70%,300px)] h-[clamp(1.75rem,5vw,2.25rem)]
            px-[2%] text-center
            box-border truncate whitespace-nowrap overflow-hidden
          "
        />
      )}
    </div>
  );
}

Signature.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default Signature;